export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="bg-gradient-to-br from-background-100 via-background-100 to-primary-500/5 rounded-xl border border-background-300/30 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
                <i className="ri-smartphone-line text-accent-400 text-xs"></i>
                <span className="text-xs text-accent-400 font-medium whitespace-nowrap">移动追综</span>
              </div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
                6080影视 APP — 随时随地高清追综艺
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-lg lg:max-w-none">
                下载6080影视移动客户端，地铁上、午休时、旅途中，随时随地打开手机就能看最新综艺。
                支持1080P高清画质、后台缓存下载、智能续播、弹幕互动，追综艺从未如此方便。
                覆盖iOS与Android双平台，安装即用，无需注册登录。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="whitespace-nowrap px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm transition-all duration-200 cursor-pointer flex items-center gap-1.5">
                  <i className="ri-apple-line text-base"></i>iOS 下载
                </button>
                <button className="whitespace-nowrap px-6 py-2.5 bg-background-300/50 hover:bg-background-400/40 text-foreground-200 font-medium rounded-lg border border-background-400/30 text-sm transition-all duration-200 cursor-pointer flex items-center gap-1.5">
                  <i className="ri-android-line text-base"></i>Android 下载
                </button>
              </div>
            </div>
            <div className="w-full max-w-[300px] lg:max-w-[340px]">
              <div className="relative aspect-[9/16] rounded-xl overflow-hidden bg-background-200/60 border border-background-300/20 mx-auto max-w-[220px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20dark%20theme%20video%20streaming%20app%20interface%20with%20variety%20show%20thumbnails%20in%20warm%20orange%20and%20amber%20accents%20modern%20minimalist%20UI%20design%20clean%20layout%20with%20grid%20of%20show%20posters%20bottom%20navigation%20bar%20floating%20on%20dark%20background%20isolated%20phone%20screen&width=440&height=780&seq=app-mock-6080-03&orientation=portrait"
                  alt="6080影视移动端界面展示"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}